import React, { useState, useEffect } from "react";
import lottie from "lottie-web";
import Menu from "../Menu";

import {
  HeaderCustom,
  LinkImage,
  LinkHeader,
  LinksHeader,
  DivEstimate,
  ButtonEstimate,
  MenuButton,
} from "./styles";
import Logo from "../Logo";
import animation from "../../static/Menu.json";

const Header = ({
  scrollToTop,
  origin,
  background,
  color,
  backgroundScroll,
}) => {
  const [visibilityMenu, setVisibilityMenu] = useState(false);
  const [styleMenu, setStyleMenu] = useState("menu-container");
  const [menuAnimation, setMenuAnimation] = useState(true);

  const _visibilityMenuFunc = () => {
    const { body } = document;

    if (visibilityMenu === false) {
      setVisibilityMenu(!visibilityMenu);
      setStyleMenu("menu-container is-menu-open");

      setMenuAnimation(true);

      lottie.loadAnimation({
        container: document.getElementById("menuAnimation"),
        animType: "svg",
        animationData: animation,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      });

      setTimeout(() => {
        setMenuAnimation(false);
      }, 550);
    }
    if (visibilityMenu === true) {
      setStyleMenu("menu-container");
      setTimeout(function() {
        setVisibilityMenu(!visibilityMenu);
      }, 300);
      setMenuAnimation(true);
    }
    visibilityMenu
      ? body.setAttribute("style", "overflow-y:auto")
      : body.setAttribute("style", "overflow-y:hidden");
  };

  return (
    <>
      <Menu
        origin={origin}
        toggleMenu={() => _visibilityMenuFunc()}
        visibilityMenu={visibilityMenu}
        menuAnimation={menuAnimation}
      />

      <HeaderCustom
        style={
          scrollToTop
            ? {
                paddingTop: "1rem",
                paddingBottom: "1rem",
                transition: "padding 0.5s",
                background: backgroundScroll,
                zIndex: "156",
              }
            : {
                transition: "padding 0.1s ",
                background,
              }
        }
      >
        <div style={{ display: "flex", width: "75%" }}>
          {" "}
          <LinkImage href="/">
            <Logo
              color={
                visibilityMenu && !menuAnimation
                  ? "#ffffff"
                  : color && !scrollToTop
                  ? color
                  : "#ffffff"
              }
            />
          </LinkImage>
          <LinksHeader>
            <LinkHeader
              style={color && !scrollToTop ? { color } : { color: "#969696" }}
              href={`${origin}/projects`}
            >
              Projects
            </LinkHeader>
            <LinkHeader
              style={color && !scrollToTop ? { color } : { color: "#969696" }}
              href={`${origin}/services`}
            >
              Services
            </LinkHeader>
            <LinkHeader
              style={color && !scrollToTop ? { color } : { color: "#969696" }}
              href={`${origin}/about`}
            >
              About
            </LinkHeader>
            <LinkHeader
              style={color && !scrollToTop ? { color } : { color: "#969696" }}
              href={`${origin}/blog`}
            >
              Blog
            </LinkHeader>
            {console.log(origin)}
            <LinkHeader
                style={color && !scrollToTop ? { color } : { color: "#969696" }}
                href={`${origin}/blog`}
            >
              Estimate App
            </LinkHeader>
          </LinksHeader>
        </div>
        <DivEstimate>
          <ButtonEstimate href={`${origin}/contact-us`}>
            Contact us
          </ButtonEstimate>
        </DivEstimate>
        <MenuButton>
          <div onClick={_visibilityMenuFunc} className={styleMenu} alt="menu">
            <div className="bars">
              <span
                style={
                  visibilityMenu
                    ? { background: "#ffffff" }
                    : color && !scrollToTop
                    ? { background: color }
                    : { background: "#ffffff" }
                }
              />
              <span
                style={
                  visibilityMenu
                    ? { background: "#ffffff" }
                    : color && !scrollToTop
                    ? { background: color }
                    : { background: "#ffffff" }
                }
              />
              <span
                style={
                  visibilityMenu
                    ? { background: "#ffffff" }
                    : color && !scrollToTop
                    ? { background: color }
                    : { background: "#ffffff" }
                }
              />
              <div className="other-bar" />
            </div>
          </div>
        </MenuButton>
      </HeaderCustom>
    </>
  );
};

export default Header;
